module.exports = ".slotsTime {\r\n  list-style: none;\r\n  float: left;\r\n  padding: 7px;\r\n  border: 1px solid;\r\n  position: relative;\r\n  width: 16.667%;\r\n  margin-bottom: 12px;\r\n  max-height: 40px;\r\n  display: -webkit-flex;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/slots/slots.component.css
// module id = ./src/app/slots/slots.component.css
// module chunks = main